<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import QuoteCard from '../QuoteCard/QuoteCard.vue';

const emit = defineEmits(['create']);

const onClick = () => {
  emit('create');
};

// Sample data for empty state preview
const sampleQuotes = [
  {
    id: 1,
    quoteNumber: 'Q-2024-001',
    title: 'Enterprise Software License Quote',
    totalAmount: 50000,
    currency: 'USD',
    status: 'sent',
    validUntil: '2024-12-31',
    companyName: 'Acme Corporation',
    contactName: 'John Smith',
    userName: 'Sales Team',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 2,
    quoteNumber: 'Q-2024-002',
    title: 'Consulting Services Quote',
    totalAmount: 25000,
    currency: 'USD',
    status: 'accepted',
    validUntil: '2024-06-30',
    companyName: 'TechStart Inc.',
    contactName: 'Sarah Johnson',
    userName: 'Jane Doe',
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: 3,
    quoteNumber: 'Q-2024-003',
    title: 'Annual Support Contract',
    totalAmount: 12000,
    currency: 'USD',
    status: 'draft',
    validUntil: '2024-09-15',
    companyName: 'Global Services Ltd.',
    contactName: 'Mike Wilson',
    userName: 'Sales Team',
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
  },
];
</script>

<template>
  <EmptyStateLayout
    :title="$t('QUOTES.EMPTY_STATE.TITLE')"
    :subtitle="$t('QUOTES.EMPTY_STATE.DESCRIPTION')"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <QuoteCard
          v-for="quote in sampleQuotes"
          :key="quote.id"
          :id="quote.id"
          :quote-number="quote.quoteNumber"
          :title="quote.title"
          :total-amount="quote.totalAmount"
          :currency="quote.currency"
          :status="quote.status"
          :valid-until="quote.validUntil"
          :company-name="quote.companyName"
          :contact-name="quote.contactName"
          :user-name="quote.userName"
          :updated-at="quote.updatedAt"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('QUOTES.EMPTY_STATE.ACTION')"
        icon="i-lucide-file-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
